import(/* webpackMode: "eager", webpackExports: ["AuthGate"] */ "/vercel/path0/blockpage411/app/components/AuthGate.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/blockpage411/app/components/Chrome.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/vercel/path0/blockpage411/app/components/Providers.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/blockpage411/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Manrope\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-body\",\"display\":\"swap\"}],\"variableName\":\"bodyFont\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/blockpage411/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Sora\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-heading\",\"display\":\"swap\"}],\"variableName\":\"headingFont\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/blockpage411/styles/globals.css");
